/*****************全局变量**************/
var model = {
  host: "http://c.dxunt315.com/api",
  newHost: "https://www.qgfw315.com",
};

/*****************路由*****************/
var router = {
  pages: null, // 所有page
  path: {
    INLET: "inlet", //入口页
    SUCCESS: "success", //查询成功页
    ERROR: "error", //错误页
    BLACKLIST: "blacklist", // 黑名单页
    REPORT: "report", //举报
    REPORT_SUCCESS: "reportSuccess", // 举报成功
  },
  init: function () {
    this.pages = $(".page");
    this.setView(this.path.SUCCESS);
  },
  setView: function (url) {
    // 隐藏全部page
    this.pages.hide();
    // 跳转到对应路由
    if (url) {
      $("#" + url).fadeIn();
      return;
    }
    // 初始化首页
    $(".home-page").fadeIn();
  },
};

/**************首页******************/
var homePage = {
  codeInput: null,
  queryBtn: null,
  codeVal: "",
  init: function () {
    this.codeInput = $("#code");
    this.queryBtn = $(".query-btn"); // 查询按钮
    this.render();
  },
  render: function () {
    var that = this;
    this.queryBtn.click(function () {
      that.codeVal = that.codeInput.val();
      // 非空判断
      if (!that.codeVal.trim()) {
        return;
      }
      // 调用接口查询
      $.ajax({
        type: "POST",
        url: model.host + "/dotmod/query" + that.codeVal,
        success: function (res) {
          var status = res.result.status;
          if (status == 0 || status == 1) {
            // 查询正确  多次查询正确
            router.setView(router.path.SUCCESS);
            successPage.init();
          } else if (status == 3 || status == 5) {
            // 查询错误
            router.setView(router.path.ERROR);
            errorPage.init();
          } else if (status == 4) {
            // 黑名单
            router.setView(router.path.BLACKLIST);
            blacklistPage.init();
          }
        },
      });
    });
  },
};

/**************查询成功页******************/
var successPage = {
  deviceName: null,
  codeVal: null,
  message: null,
  init: function () {
    var successCodeInfo = $("#successCodeInfo");
    this.message = successCodeInfo.find("#message");
    this.deviceName = successCodeInfo.find("#device");
    this.codeVal = successCodeInfo.find("#codeVal");
    this.render();
  },
  render: function () {
    var that = this;

    // 获取当前页面的 URL
    const url = new URL(window.location.href);

    // 获取 fwcode 参数的值
    const fwcode = url.searchParams.get("fwcode");

    const md5Hash = CryptoJS.MD5(
      "0c41IUULx8ha4RCM0Zldy8hdCMJcmnXhJAyTGR2dABug" + fwcode
    ).toString();
    // 查询
    // var request_ajax = undefined;
    // try{
    // alert(wx);
    //   request_ajax = wx.request;
    // }catch(e){
    //   request_ajax = $.ajax;
    // }
     $.ajax({
      type: "POST",
      dataType:"JSON",
      async: true, //加上之后不在跳转进error
       // 告诉jQuery不要去处理发送的数据
    processData: false,
    // 告诉jQuery不要去设置Content-Type请求头
    contentType: false,
      url:
        model.newHost +
        "/dotmod/query?fwcode=" +
        fwcode +
        "&sture=" +
        md5Hash +
        "&ip=0.0.0.0",
      error: function (params) {
        alert(JSON.stringify(params));
      },
      success: function (res) {
        var data = res.data;
        console.log(data);
        that.message.text(data.res_msg);
        that.deviceName.text(data.res_proinfo.pro_name);
        that.codeVal.text(fwcode);

        // var list = res.result.list;
        // var number = "";
        // // 特殊次数处理 1，2，3，21 是特殊的 1st，2nd，3rd，21st，其它的都是th
        // if (list.length === 1 || list.length === 21) {
        //     number = list.length + "st";
        // } else if (list.length === 2) {
        //     number = list.length + "nd";
        // } else if (list.length === 3) {
        //     number = list.length + "rd";
        // } else {
        //     number = list.length + "th";
        // }
        // that.number.text(number);

        // // 遍历查询历史
        // str = "";
        // if (list && list.length >= 2) {
        //     that.historyListLabel.fadeIn(); //显示label
        //     list.forEach(function (item, idx) {
        //         str += '<li class="item">' + item.createTime + "</li>";
        //     });
        //     that.historyList.append(str);
        // }
      },
    });
  },
};

/*************查询错误页************/
var errorPage = {
  reportBtn: null,
  tryAgain: null,
  init: function () {
    this.reportBtn = $(".report-btn");
    this.tryAgain = $(".try-again-btn");
    this.render();
  },
  render: function () {
    // 举报
    this.reportBtn.click(function () {
      router.setView(router.path.REPORT);
      reportPage.init();
    });

    // 在试一次
    this.tryAgain.click(function () {
      router.setView();
    });
  },
};

/************黑名单页***********/
var blacklistPage = {
  reportBtn: null,
  tryAgain: null,
  init: function () {
    this.reportBtn = $("#blacklist").find(".report-btn");
    this.tryAgain = $("#blacklist").find(".try-again-btn");
    this.render();
  },
  render: function () {
    // 举报
    this.reportBtn.click(function () {
      router.setView(router.path.REPORT);
      reportPage.init();
    });

    // 在试一次
    this.tryAgain.click(function () {
      router.setView();
    });
  },
};

/***************举报页*************/
var reportPage = {
  submitBtn: null,
  uploadImgBtn: null,
  uploadImgListBox: null,
  maxLength: 5, // 最大上传图个数
  uploadImgList: [], // 已上传列表
  imagKeyList: [], // 已上传图片key集合
  channelAddress: null, // 购物地址
  name: null, //联系人
  email: null, //邮箱
  init: function () {
    this.uploadImgBtn = $("#uploadImg");
    this.uploadImgListBox = $("#uploadImgList");
    this.channelAddress = $(".report-form #channelAddress");
    this.name = $(".report-form #name");
    this.email = $(".report-form #email");
    this.submitBtn = $(".report-form .submit-btn");
    var dom = this.renderUploadDom();
    this.uploadImgListBox.append(dom);
    this.render();
  },
  render: function () {
    var that = this;

    // 事件代理，上传图片
    this.uploadImgListBox.on("change", "#uploadImg", function (e) {
      var files = e.currentTarget.files;
      // 大小限制
      //       if (Math.floor(files[0].size / 1024 > 5120)) {
      //         // 弹窗
      //         layer.open({
      //           content: 'The image cannot be larger than 5M!',
      //           btn: 'OK'
      //         })
      //         return
      //       }

      // 加载层
      layer.open({ type: 2, shadeClose: false });

      // 参数
      var formData = new FormData();
      var key =
        "report/" +
        new Date().getTime() +
        Math.ceil(Math.random() * 100000) +
        files[0].name;
      formData.append("key", key);
      formData.append("file", files[0]);

      $.ajax({
        type: "POST",
        contentType: false,
        url: model.host + "/console/oss/upload",
        processData: false,
        dataType: "json",
        data: formData,
        success: function (result) {
          // 显示本地
          var img = that.getObjectURL(files[0]);
          that.uploadImgList.push(img);
          that.imagKeyList.push(key);

          // 遍历添加图片
          var str = "";
          that.uploadImgList.forEach(function (item) {
            str +=
              '<li class="item"><img src="' +
              item +
              '" alt="" width="100%" height="100%"></li>';
          });

          // 判断已上传图片是否超过最大上传数
          if (that.uploadImgList.length < that.maxLength) {
            var dom = that.renderUploadDom();
            str += dom;
          }
          // 先清空dom， 在添加
          that.uploadImgListBox.empty().prepend(str);

          // 关闭弹窗
          layer.closeAll();
        },
        error: function (error) {
          that.uploadImgBtn.val("");
          layer.closeAll();
          layer.open({
            content: "upload failed!",
            btn: "OK",
          });
          console.log(err);
        },
      });
    });

    // 举报
    this.submitBtn.click(function () {
      var channelAddress = that.channelAddress.val().trim(),
        name = that.name.val().trim(),
        email = that.email.val().trim();

      // 非空判断
      if (!(channelAddress && name && email && that.imagKeyList.length > 0)) {
        layer.open({
          content: "Information cannot be empty!",
          btn: "OK",
        });
        return;
      }

      $.ajax({
        type: "POST",
        url: model.host + "/pc/report/dotmod/" + homePage.codeVal,
        data: {
          purchase: 0,
          purchaseAddr: channelAddress,
          contactName: name,
          contactAddr: email,
          imgs: that.imagKeyList.join(","),
        },
        success: function (res) {
          router.setView(router.path.REPORT_SUCCESS);
        },
      });
    });
  },
  renderUploadDom: function () {
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    var str = "";
    if (isiOS) {
      str +=
        '<li class="item"><img src="//cdn.shopify.com/s/files/1/0967/9486/t/52/assets/upload-img.png" alt="" width="100%" height="100%"><input type="file" accept="image/*" id="uploadImg" /></li>';
    } else {
      str +=
        '<li class="item"><img src="//cdn.shopify.com/s/files/1/0967/9486/t/52/assets/upload-img.png" alt="" width="100%" height="100%"><input type="file" accept="image/*" capture="camera" id="uploadImg" /></li>';
    }
    return str;
  },
  getObjectURL: function (file) {
    var url = null;
    if (window.createObjectURL != undefined) {
      // basic
      url = window.createObjectURL(file);
    } else if (window.URL != undefined) {
      // mozilla(firefox)
      url = window.URL.createObjectURL(file);
    } else if (window.webkitURL != undefined) {
      // webkit or chrome
      url = window.webkitURL.createObjectURL(file);
    }
    return url;
  },
};

// 页面加载完成，初始化页面数据
$(function () {
  router.init();
  successPage.init();
});
